/**
 * Accessibility Fix: perweb-AMP30 - ADA Focus Order Fix for Boost-SD Carousels
 * Desired DOM Order: Prev Button -> Slides Track -> Next Button -> Dots
 */


document.addEventListener('DOMContentLoaded', () => {
  // 1. Initialize MutationObserver to catch async Boost elements
  const observer = new MutationObserver((mutations) => {
    
    // Find all Boost sliders that haven't been fixed yet to prevent infinite loops
    // Adjust the generic wrapper class if your specific setup differs slightly
    const sliders = document.querySelectorAll('.boost-sd__slider:not([data-ada-fixed="true"]), .boost-sd__recommendation-block:not([data-ada-fixed="true"])');

    sliders.forEach(slider => {
      // 2. Target the specific UI controls inside the slider wrapper
      const prevBtn = slider.querySelector('button[aria-label="Previous"], button.boost-sd__slider-button-prev');
      const nextBtn = slider.querySelector('button[aria-label="Next"]');
      
      // Target the container holding the actual product cards
      const track = slider.querySelector('.boost-sd__slider-list, .boost-sd__slider-wrapper'); 
      
      // Target the pagination dots
      const dots = slider.querySelector('.boost-sd__slider-pagination'); 

      // 3. If the core interactive elements exist, reorder them in the DOM
      if (prevBtn && nextBtn && track) {
        
        // Use modern DOM insertion methods to enforce the logical structure
        slider.prepend(prevBtn);      // 1. Move "Previous" to the very beginning
        prevBtn.after(track);         // 2. Ensure "Slides Track" immediately follows "Previous"
        track.after(nextBtn);         // 3. Move "Next" immediately after the "Slides Track"
        
        if (dots) {
          nextBtn.after(dots);        // 4. Move "Slider Controls (Dots)" to the very end
        }

        // Flag the element as fixed to stop the observer from re-running on it
        slider.setAttribute('data-ada-fixed', 'true');
      }
    });
  });

  // 4. Start observing the body for DOM changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});




/**
 * Accessibility Fix: perweb-AMP28 - Associate dynamic app error messages with their inputs
 * Target: Docapp Coupon Input & Email Inputs
 */


document.addEventListener('DOMContentLoaded', () => {
  // Select the main wrapper injected by the app
  const appContainer = document.querySelector('.docapp-coupon-input.docapp-in-summary');
  
  if (!appContainer) return; // Exit if the app isn't loaded on this page

  // Configuration for the observer: watch for added elements and attribute changes (like display: none to block)
  const observerConfig = { 
    childList: true, 
    subtree: true, 
    attributes: true, 
    attributeFilter: ['style', 'class'] 
  };

  const handleAppMutations = (mutationsList, observer) => {
    // 1. Target the specific input from the ADA report
    const couponInput = appContainer.querySelector('input[name="temp-discount"]');
    
    // REPLACE '.docapp-coupon-error' WITH THE ACTUAL CLASS OF THE ERROR DIV YOU INSPECTED IN STEP 1
    const errorMessageNode = appContainer.querySelector('.docapp-coupon-error'); 

    if (couponInput && errorMessageNode) {
      // Check if the error message is actually visible to the user
      const isErrorVisible = errorMessageNode.offsetWidth > 0 || errorMessageNode.offsetHeight > 0 || errorMessageNode.style.display !== 'none';
      const hasErrorText = errorMessageNode.textContent.trim() !== '';

      if (isErrorVisible && hasErrorText) {
        // Ensure the error node has a unique ID to link to
        const errorId = errorMessageNode.id || 'docapp-error-' + Math.random().toString(36).substring(2, 9);
        if (!errorMessageNode.id) {
          errorMessageNode.id = errorId;
        }

        // Apply ADA attributes to the input
        couponInput.setAttribute('aria-describedby', errorId);
        couponInput.setAttribute('aria-invalid', 'true');
      } else {
        // Clean up attributes if the error is resolved/hidden
        couponInput.removeAttribute('aria-describedby');
        couponInput.removeAttribute('aria-invalid');
      }
    }
  };

  // Initialize and start the observer
  const appObserver = new MutationObserver(handleAppMutations);
  appObserver.observe(appContainer, observerConfig);
});




/**
 * ADA FIX: perweb–AMP25 – Ensure custom controls provide proper textual name, role, and state information
 */


document.addEventListener("DOMContentLoaded", () => {
  const fixBoostAdaLinks = () => {
    // Target Boost swatch buttons that haven't been fixed yet
    const buttons = document.querySelectorAll('button.boost-sd__product-swatch-more:not(.ada-fixed)');

    buttons.forEach(button => {
      // 1. Find the parent product card container
      const productCard = button.closest('.boost-sd__product-item, .grid-product');
      if (!productCard) return;

      // 2. Extract the product title and URL from the main product link
      const titleLink = productCard.querySelector('a.boost-sd__product-title, a.grid-product__title, a[href*="/products/"]');
      
      // Fallbacks in case the DOM structure varies slightly
      const productTitle = titleLink ? titleLink.textContent.trim() : 'this product';
      const productUrl = titleLink ? titleLink.getAttribute('href') : '#';

      // 3. Create the new, accessible native <a> element
      const anchor = document.createElement('a');
      anchor.href = productUrl;
      
      // Preserve all Boost classes for styling, plus a flag to prevent infinite loops
      anchor.className = button.className + ' ada-fixed';
      
      // 4. Set the contextual aria-label (e.g., "Show more options for Ribbed Crew Neck Tee")
      anchor.setAttribute('aria-label', `Show more options for ${productTitle}`);
      
      // Preserve the "+" inner HTML
      anchor.innerHTML = button.innerHTML;

      // 5. Replace the inaccessible button with the new anchor
      button.replaceWith(anchor);
    });
  };

  // Run immediately on page load for any server-rendered products
  fixBoostAdaLinks();

  // 6. Set up a MutationObserver to handle Boost's AJAX filtering/pagination
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldRun = true;
        break;
      }
    }
    // Re-run the fix if new products were injected into the DOM
    if (shouldRun) {
      fixBoostAdaLinks();
    }
  });

  // Attach the observer to the body to watch for Boost's DOM updates
  const targetNode = document.querySelector('body');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }
});



/**
 * ADA Fix: perweb–AMP23 – Ensure custom controls provide proper textual name, role, and state information
 */ 


document.addEventListener('DOMContentLoaded', function() {
  // Wait to ensure jQuery is loaded (Slick Carousel requires it)
  var checkJquery = setInterval(function() {
    if (typeof window.jQuery !== 'undefined') {
      clearInterval(checkJquery);
      initSlickAccessibilityFix();
    }
  }, 100);

  function initSlickAccessibilityFix() {
    var $ = window.jQuery;

    // Core function to update the ARIA attributes
    function updateSlickAccessibility(slider) {
      var $slider = $(slider);
      
      $slider.find('.slick-dots li button').each(function() {
        var $btn = $(this);
        
        // Extract the number from the button text (e.g., "1")
        var slideNum = $btn.text().replace(/\D/g, ''); 
        
        // Satisfy the "Go to slide X" requirement if missing
        if (slideNum) {
            $btn.attr('aria-label', 'Go to slide ' + slideNum);
        }
        
        // Remove aria-current from all buttons to prevent duplicates
        $btn.removeAttr('aria-current');
      });

      // Find the active slide dot and apply aria-current="true"
      $slider.find('.slick-dots li.slick-active button').attr('aria-current', 'true');
    }

    // Delegate event listeners for dynamically injected sliders
    $(document).on('init afterChange', '.slick-slider, .boost-sd__slider-container', function(event) {
      updateSlickAccessibility(event.target);
    });

    // Fallback: Fire once to catch sliders that initialized before the script ran
    setTimeout(function() {
      $('.slick-slider, .boost-sd__slider-container, .slick-initialized').each(function() {
        updateSlickAccessibility(this);
      });
    }, 1500); 
  }
});


/**
 * ADA Fix: Programmatically group visually related swatches
 * Targets elements with boost-sd classes to wrap them in a fieldset/legend
 */ 


(function() {
   // console.log("ADA Fix: Script Loaded");

  const applyA11yFix = () => {
    // 1. Target the specific labels from your screenshot
    const swatches = document.querySelectorAll('.boost-sd__radio-label:not(.ada-fixed)');
    
    if (swatches.length === 0) return;

     // console.log(`ADA Fix: Found ${swatches.length} swatches to fix.`);

    // 2. Identify the group. Usually, swatches are siblings in one container.
    // We target the parent of the labels.
    const container = swatches[0].parentElement;

    if (container && container.tagName !== 'FIELDSET') {
      // Create the fieldset
      const fieldset = document.createElement('fieldset');
      fieldset.setAttribute('role', 'radiogroup');
      fieldset.className = 'ada-fieldset-wrapper';
      
      // Inline styles to prevent layout shifts
      fieldset.style.border = 'none';
      fieldset.style.padding = '0';
      fieldset.style.margin = '0';

      // Create the Legend (Visible for ADA, but styled to match theme)
      const legend = document.createElement('legend');
      //legend.innerText = 'Color'; 
      //legend.className = 'variant__label'; // Using Impulse's native label class
      
      // 3. Manipulation: Move container contents into fieldset
      container.parentNode.insertBefore(fieldset, container);
      fieldset.appendChild(legend);
      fieldset.appendChild(container);

      // 4. Mark swatches as fixed
      swatches.forEach(s => s.classList.add('ada-fixed'));
       // console.log("ADA Fix: Fieldset successfully injected.");
    }
  };

  // Run on load
  window.addEventListener('load', applyA11yFix);

  // Run on mutations (for Quick View and Boost dynamic loading)
  const observer = new MutationObserver((mutations) => {
    applyA11yFix();
  });

  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
})();






/**
 * ADA AMP129 - WAIR - 3rd Party App - FIX
 */

(function fixAppAccessibility() {
  // Selector for the container holding the dots
  const dotsContainerSelector = '.wr-flex.wr-items-center.wr-gap-3';

  function enhanceDots() {
    const containers = document.querySelectorAll(dotsContainerSelector);
    
    containers.forEach(container => {
      // Add a label to the container
      if (!container.hasAttribute('role')) {
        container.setAttribute('role', 'group');
        container.setAttribute('aria-label', 'Slide controls');
      }

      const dots = container.querySelectorAll('span.wr-rounded-full');
      dots.forEach((dot, index) => {
        // Only apply if we haven't already fixed this dot
        if (!dot.hasAttribute('tabindex')) {
          dot.setAttribute('tabindex', '0');
          dot.setAttribute('role', 'button');
          dot.setAttribute('aria-label', `Go to Slide ${index + 1}`);
          
          // Determine if active based on background color class
          const isActive = dot.classList.contains('wr-bg-gray-800');
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');

          // Add keyboard event listener
          dot.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              dot.click();
            }
          });
        }
      });
    });
  }

  // Run once immediately in case it's already in the DOM
  enhanceDots();

  // Set up a MutationObserver to catch the modal if it's rendered dynamically
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        enhanceDots();
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();



/**
 * ADA AMP118 fix aria-label added to product PDP images and zoom feature.
*/


document.addEventListener('DOMContentLoaded', function() {
  // Select the product slides or image wrappers
  const productImageContainers = document.querySelectorAll('.product-main-slide, .image-wrap');

  productImageContainers.forEach(function(container) {
    // Listen for keyboard events on the container
    container.addEventListener('keydown', function(event) {
      // Check if the key pressed is Enter (13) or Space (32)
      if (event.key === 'Enter' || event.key === ' ') {
        // Prevent default browser behavior (like scrolling down on Space)
        event.preventDefault(); 
        
        // Find the zoom button within this specific slide and trigger a click
        const zoomButton = this.querySelector('.js-photoswipe__zoom');
        if (zoomButton) {
          zoomButton.click();
        }
      }
    });
  });
});




/**
 * ADA AMP117 fix Reorders Yotpo Custom Questions DOM for Screen Readers
 * Matches Titles and Values based on their CSS Grid inline styles
 */


(function() {

    function fixYotpoReadingOrder() {
      // Find all custom question titles that haven't been processed yet
      const titles = document.querySelectorAll('.yotpo-custom-questions-title:not([data-a11y-processed])');
      
      if (titles.length === 0) return;

      // Find unique parent containers for these titles
      const containers = new Set();
      titles.forEach(title => containers.add(title.parentElement));

      containers.forEach(container => {
        // Get all titles in this specific container
        const containerTitles = Array.from(container.querySelectorAll('.yotpo-custom-questions-title:not([data-a11y-processed])'));
        
        containerTitles.forEach(title => {
          // Identify the exact row this title belongs to visually
          const rowStart = title.style.gridRowStart;
          
          if (!rowStart) return;

          // Find the corresponding value element in the same container.
          // It's the sibling element that is NOT a title, but shares the same grid-row-start.
          const valueElement = Array.from(container.children).find(sib => 
            !sib.classList.contains('yotpo-custom-questions-title') && 
            sib.style.gridRowStart === rowStart
          );

          if (valueElement) {
            // Reorder in the DOM: Append title first, then its value immediately after.
            // Because they use explicit grid-row-start styles, this will NOT break the visual layout.
            container.appendChild(title);
            container.appendChild(valueElement);
            
            // Mark as processed to prevent infinite loops with MutationObserver
            title.setAttribute('data-a11y-processed', 'true');
            valueElement.setAttribute('data-a11y-processed', 'true');
          }
        });
      });
    }

    // Set up a MutationObserver to watch for Yotpo's async loading and pagination changes
    function initYotpoObserver() {
      const observer = new MutationObserver((mutations) => {
        let shouldRun = false;
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length > 0) {
            shouldRun = true;
          }
        });

        if (shouldRun) {
          // Give Yotpo's internal scripts a brief moment to finish painting the DOM
          requestAnimationFrame(() => {
            fixYotpoReadingOrder();
          });
        }
      });

      // Start observing the body for injected Yotpo nodes
      observer.observe(document.body, { childList: true, subtree: true });
      
      // Run once immediately in case elements are already present
      fixYotpoReadingOrder();
    }

    // Initialize script on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initYotpoObserver);
    } else {
      initYotpoObserver();
    }
  })();


/**
 * ADA Fix for Yotpo Smart Topics "Show More" Button
 * Fixes: Incorrect role, missing state, missing keyboard access, and focus management.
 */
function fixYotpoAccessibility() {
  const toggleBtn = document.querySelector('.yotpo-smart-topics-see-more-label');
  
  // Exit if the button isn't there or if we've already fixed it
  if (!toggleBtn || toggleBtn.hasAttribute('data-ada-fixed')) return;

  // 1. Correct the Role and Attributes
  toggleBtn.setAttribute('data-ada-fixed', 'true'); // Mark as fixed
  toggleBtn.setAttribute('role', 'button');
  toggleBtn.setAttribute('aria-expanded', 'false');
  toggleBtn.removeAttribute('aria-pressed'); // Remove incorrect toggle state
  
  // Enforce a static name as recommended by the audit
  toggleBtn.textContent = 'Additional Popular Topics'; 

  // 2. Keyboard Support (Enter and Space)
  toggleBtn.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleBtn.click(); // Trigger native app click
    }
  });

  // 3. State Management & Focus Routing on Click
  toggleBtn.addEventListener('click', function() {
    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    toggleBtn.setAttribute('aria-expanded', !isExpanded);

    // Use a slight timeout to let Yotpo's internal script run and reveal the items
    setTimeout(() => {
      // Force text back in case Yotpo attempts to change it to "Show less"
      toggleBtn.textContent = 'Additional Popular Topics';

      if (!isExpanded) {
        // Move focus to the first newly revealed topic.
        // Yotpo generally shows 5-10 initially. We target the hidden ones that just appeared.
        // NOTE: You may need to adjust the nth-child index based on your specific Yotpo settings.
        const newlyRevealedTopic = document.querySelector('.yotpo-smart-topic-filter:nth-child(6)'); 
        
        if (newlyRevealedTopic) {
          // Make it programmatically focusable and move focus
          newlyRevealedTopic.setAttribute('tabindex', '-1');
          newlyRevealedTopic.focus();
        }
      }
    }, 150);
  });
}

// 4. MutationObserver to watch for Yotpo's asynchronous loading
const yotpoObserver = new MutationObserver((mutations) => {
  if (document.querySelector('.yotpo-smart-topics-see-more-label')) {
    fixYotpoAccessibility();
  }
});

// Start observing the document body
yotpoObserver.observe(document.body, { childList: true, subtree: true });


// 1. Create a variable to hold the trigger element globally
window.lastModalTrigger = null;

// 2. Listen for the click on the "Learn more" button
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('#shopify-installments-cta');
  
  if (trigger) {
    // Store the button so we can find it later
    window.lastModalTrigger = trigger;
  }
});

// 3. Listen for the "Close" action
// Shopify's installments modal usually triggers a 'close' event or removes a specific class
document.addEventListener('click', function (event) {
  // Check if the clicked element is a close button or the overlay backdrop
  if (event.target.matches('.shopify-installments-modal__close') || 
      event.target.matches('.shopify-installments-modal-backdrop')) {
    
    if (window.lastModalTrigger) {
      // Return focus to the "Learn more" link
      window.lastModalTrigger.focus();
    }
  }
});


document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape' && window.lastModalTrigger) {
    // Small delay to ensure the modal has finished its closing animation
    setTimeout(() => {
      window.lastModalTrigger.focus();
    }, 100);
  }
});
